import React from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import ApplySection from "../components/ApplyData";
import Footer from "../components/Footer";
import { getEmailLogo } from "../utils/emailLogo";

const ApplyJob = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Apply Job | VisionBird</title>
        <meta
          name="description"
          content="Apply for the Senior Photoshop / Illustrator job at VisionBird Technologies. Submit your application and join our creative team."
        />
        <meta
          name="keywords"
          content="VisionBird jobs, Photoshop job Pakistan, Illustrator job, design jobs, apply job VisionBird"
        />
      </Helmet>

      <Navbar />

      <ApplySection
        formTitle="Apply Form"
        resumeImg="/assets/Images/paper_clip_light.png"
        jobDate="06 AUG, 2025"
        jobIcon="/assets/Images/Subtract (4).png"
        jobCategory="Marketing Ads"
        jobTitle="Senior Photoshop / Illustrator Master"
        requirements={["Photoshop", "Illustrator", "Gimp", "Adobe Fonts Maker"]}
        salary="Based on interview and past experience."
        description="We value individuals who bring a constructive and innovative mindset to their work. Whether you're seeking a permanent position or an internship, just fill out the form below and hit 'Send.' We'll review your application, and if you meet our criteria, we’ll get in touch to schedule an interview."
        location={`B-343, Pagganwala Street,
Near Cheema Masjid, Shadman Colony,
Gujrat, Pakistan.`}
        jobTypes={["Office Based", "Full Time"]}
      />

      <Footer />
    </>
  );
};

export default ApplyJob;